<template>
  <div class="c-sitter__detail">
    <Avatar v-if="sitterPhotoUrl" :image-url="sitterPhotoUrl" :size="AvatarSize.MEGA" :name="sitterName" class="mr-8" />
    <div class="c-detail__wrapper">
      <h2 class="c-sitter__name break-all">{{ sitterName }}</h2>
      <div v-if="hasRating" id="star__badge" class="c-star__badge flex">
        <star-icon v-for="stars in fullStarNumber" :key="`full-star-${stars}`" class="mr-4" color="#ff0064" />
        <star-outline-icon v-for="stars in emptyStarNumber" :key="`empty-star-${stars}`" class="mr-4" color="#ff0064" />
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import Avatar, { AvatarSize } from '@/components/avatar/Avatar.vue';
import StarIcon from '@/graphics/icons/StarIcon.vue';
import StarOutlineIcon from '@/graphics/icons/StarOutlineIcon.vue';

const scores = {
  FIVE_STARS: 5,
  FOUR_STARS: 4,
  THREE_STARS: 3,
  TWO_STARS: 2,
  ONE_STAR: 1,
};

export default {
  name: 'SitterDetailsHeader',
  components: {
    Avatar,
    StarIcon,
    StarOutlineIcon,
  },
  props: {
    sitterPhotoUrl: {
      type: String || null,
      default: null,
    },
    sitterName: {
      type: String,
      required: true,
    },
    hasRating: {
      type: Boolean,
    },
    ratingScore: {
      type: String,
      default: '',
      required: false,
    },
  },
  data() {
    return {
      AvatarSize,
    };
  },
  computed: {
    fullStarNumber(): number {
      return scores[this.ratingScore];
    },
    emptyStarNumber(): number {
      return 5 - this.fullStarNumber;
    },
  },
};
</script>
